import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore'
import languages from "../../utils/languages";

const config = {
    apiKey: "AIzaSyDDedoxAIP7ethTDyJjWqkdG1ljINMdwuw",
    authDomain: "translate-ee6ad.firebaseapp.com",
    databaseURL: "https://translate-ee6ad.firebaseio.com",
    projectId: "translate-ee6ad",
    storageBucket: '',
    messagingSenderId: "956806523217",
};

class Firebase {

    constructor() {
        app.initializeApp(config);
        this.auth = app.auth();
        this.db = app.firestore();
    }

    me = () => {
        if(!this.auth.currentUser.uid) return null;
        return this.db.collection("users").doc(this.auth.currentUser.uid)
    };

    signIn = () => {
        return this.auth.signInAnonymously().then(value => {
            if(value.additionalUserInfo.isNewUser) {
                this.createUser(value.user.uid,"anonymous");
            }
        })
    };

    createUser = (uid,source) => {
        return this.db.collection("users").doc(uid).set({
            createdAt: Date(),
            source: source
        }, { merge: true });
    };

    signInWithGoogle = () => {
        const provider = new app.auth.GoogleAuthProvider();
        this.auth.signInWithRedirect(provider);
    };

    projects = () => this.db.collection("projects");
    project = (id) => this.projects().doc(id);
    existingTranslations = (project,lang) => this.project(project).collection("translations").doc(lang);

    getProjects() {
        return this.projects().get().then(query => {
            var docs = [];
            query.forEach(doc => {
                docs.push({...doc.data(), id: doc.id});
            });
            return docs
        })
    }

    getProject(id) {
        return this.project(id).get().then(doc => {
            return doc.data()
        })
    }

    getExistingTranslations(id,lang) {
        return this.existingTranslations(id,lang).get().then(doc => {
            return doc.data();
        })
    }

    addSubmission(project,language,translations) {
        return this.db.collection("submissions").add({
            user: this.auth.currentUser.uid,
            language: language,
            project: project,
            translations: translations
        });
    }

    getSubmissions() {
        return this.db.collection("submissions");
    }

    rejectSubmissionEntry(submissionId,key) {
        this.db.collection("submissions").doc(submissionId).update({
            [`translations.${key}`]: app.firestore.FieldValue.delete()
        })
    }

    deleteSubmission(submissionId) {
        this.db.collection("submissions").doc(submissionId).delete()
    }

    approveSubmission(submissionId) {
        this.db.runTransaction(async transaction => {
            const _submission = await transaction.get(this.db.collection("submissions").doc(submissionId));
            const submission = _submission.data();
            const project = submission.project;
            const language = submission.language;
            const translations = submission.translations;
            const keys = Object.keys(translations);

            if(project && language && keys.length>0) {
                transaction.set(this.existingTranslations(project,language),{
                    ...translations
                },{merge:true});
            }

            transaction.delete(this.db.collection("submissions").doc(submissionId));
        });
    }

    uploadFile(projectId,strings) {
        this.db.runTransaction(async transaction => {
            const _project = await transaction.get(this.project(projectId));
            const project = _project.data();

            const deletedStrings = [];
            const addedStrings = [];
            const updatedStrings = [];

            const oldKeys = project.strings ? Object.keys(project.strings) : [];
            const newKeys = Object.keys(strings);

            oldKeys.forEach(key => {
                if(!newKeys.includes(key)) {
                    deletedStrings.push(key);
                }
            });

            newKeys.forEach(key => {
               if(!oldKeys.includes(key)) {
                   addedStrings.push(key);
               } else if(strings[key] !== project.strings[key]) {
                   updatedStrings.push(key);
               }
            });

            const diff = {};
            const deleteFromTranslations = {};

            deletedStrings.forEach(toDelete => {
                diff[`strings.${toDelete}`] = app.firestore.FieldValue.delete();
                deleteFromTranslations[toDelete] = app.firestore.FieldValue.delete();
            });

            addedStrings.forEach(toAdd => {
               diff[`strings.${toAdd}`] = strings[toAdd];
            });

            updatedStrings.forEach(toAdd => {
                diff[`strings.${toAdd}`] = strings[toAdd];
                deleteFromTranslations[toAdd] = app.firestore.FieldValue.delete(); // delete old version
            });


            const languageKeys = Object.keys(languages);

            languageKeys.forEach(lang => {
                transaction.set(this.existingTranslations(projectId,lang),deleteFromTranslations, {merge:true});
            });

            transaction.update(this.project(projectId),diff);

            alert(`${addedStrings.length} strings added, ${deletedStrings.length} strings deleted, ${updatedStrings.length} strings updated`);
        });
    }
}

export default Firebase;